import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import styles from "./SliderComp.module.css";

export default function SliderComp({ testimonials = [] }) {
  const trackRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    if (!trackRef.current || testimonials.length === 0) {
      return undefined;
    }

    animationRef.current = gsap.to(trackRef.current, {
      yPercent: -50,
      duration: 12,
      ease: "none",
      repeat: -1,
    });

    return () => animationRef.current?.kill();
  }, [testimonials]);

  const sliderItems = [...testimonials, ...testimonials];

  return (
    <div
      className={styles.sliderShell}
      onMouseEnter={() => animationRef.current?.pause()}
      onMouseLeave={() => animationRef.current?.resume()}
    >
      <div className={styles.viewport}>
        <div ref={trackRef} className={styles.track}>
          {sliderItems.map((item, index) => (
            <article key={`${item.name}-${index}`} className={styles.card}>
              <h3>{item.name}</h3>
              <p>{item.review}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
